import { redirect } from "react-router"

export const loader = async () => {
  const { authPayload } = await window.domain.GetAuthPayloadAuthUseCase.execute()

  if (!authPayload) {
    return redirect("/sign-in")
  }

  return null
}
